import { DialogTranslations } from '@/assets/locales/components/dialog/dialog.translations.en';

export const dialogTranslations: DialogTranslations = {
  content: {
    button: {
      cancel: 'Anuluj',
      confirm: 'Potwierdź',
    },
    title: {
      warning: 'Uwaga',
    },
  },
};
